export default {
  dialogById: state => id => state.items.find(dialog => dialog.id === id),
  openedDialog: state => state.items.find(dialog => dialog.visible),
}
